<!-- 课程表 -->
<template>
    <div>
      <div class="course_Timetable">
        <el-row class="content_block">
          <el-row class="title_head mb20">
            <!-- <el-date-picker
              v-model="value1"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker> -->
            <label>状态：</label>
            <el-select clearable class="mb20" v-model="status" placeholder="请选择状态">
              <el-option label="进行中" value="1"></el-option>
              <el-option label="已结束" value="2"></el-option>
              <el-option label="未开始" value="3"></el-option>
            </el-select>
            <el-button type="primary" icon="el-icon-search" @click="getInfo(page = 1)">搜索</el-button>
            <el-button type="success" v-if="tag != 1" icon="el-icon-printer" @click="ImportInfo">导入课表</el-button>
            <el-button type="success" v-if="tag != 1" icon="el-icon-plus" @click="addInfo">创建课表</el-button>
          </el-row>
          <el-row>
            <el-table
              :data="tableData"
              border
              style="width: 100%">
              <el-table-column type="index" header-align="center" align="center" label="序号" width="100"> </el-table-column>
              <el-table-column prop="teacherOpenCourseScheduleSession.teacherOpenCourseScheduleSessionStartDate" header-align="center" align="center" label="上课日期">
                <template v-slot="scope">
                  {{scope.row.teacherOpenCourseScheduleSession.teacherOpenCourseScheduleSessionStartDate}}~{{scope.row.teacherOpenCourseScheduleSession.teacherOpenCourseScheduleSessionEndDate}}
                </template>
              </el-table-column>
              <el-table-column prop="teacherOpenCourseScheduleSession.teacherOpenCourseScheduleSessionWeekNum" header-align="center" align="center" label="周次" width="100"> </el-table-column>
              <el-table-column prop="schoolClassIdsText" header-align="center" align="center" label="班级">
                <template slot-scope="scope">
                  <template v-if="!$isEmpty(scope.row.teacherOpenCourseScheduleSession.schoolClassIdsText)">
                    <el-tag class="m5" v-for="(item,index) in scope.row.teacherOpenCourseScheduleSession.schoolClassIdsText.split(',')" :key="index">{{item}}</el-tag>
                  </template>
                </template>
              </el-table-column>
              <el-table-column prop="skxq" header-align="center" align="center" label="上课时间">
                <template slot-scope="scope">
                  <template v-for="(item,index) in scope.row.teacherOpenCourseScheduleSession.sessionTags">
                    <p class="m5">
                      <el-tag v-if='!$isEmpty(item.sessionTagName)'>{{item.sessionTagName}}</el-tag>
                      <el-tag>
                        {{item.sessionTagTime}}
                      </el-tag>
                      <el-tag>
                        {{item.sessionClassName}}
                      </el-tag>
                    </p>
                  </template>
                </template>
              </el-table-column>
              <!-- <el-table-column prop="sksj" header-align="center" align="center" label="上课时间"> </el-table-column> -->
              <!-- <el-table-column prop="sessionClassListText" header-align="center" align="center" label="上课地点"> </el-table-column> -->
              <el-table-column prop="teacherOpenCourseScheduleSession.beginStatus.beginStatusText" header-align="center" align="center"  width="200" label="状态">
                <!-- <template slot-scope="scope">
                  <el-link :type="scope.row.type == 1?'primary':'danger'" :underline="false">
                    {{scope.row.type == 1?'进行中':'已结束'}}
                  </el-link>
                </template> -->
              </el-table-column>
            </el-table>
            <div class="block" style="text-align: right;bottom: 0;width: 96%;margin: 20px;">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="page"
                :page-sizes="[8, 20, 50, 100]"
                :page-size="limit"
                background
                :hide-on-single-page="false"
                layout="sizes, prev, pager, next,jumper"
                :total="total">
              </el-pagination>
            </div>
          </el-row>
        </el-row>

        <!-- 导入课表对话框 -->
        <el-dialog
          title="导入课表"
          :visible.sync="importShow"
          width="500px"
        >
          <span slot="title">
            <i class="el-icon-date" style="margin-right: 10px;color: #409EFF;"></i>导入课表
          </span>
          <el-select clearable style="width: 100%;" class="mb20" v-model="teacherOpenCourseScheduleSessionIds" placeholder="请选择课程名称">
            <template v-for="item in courseList">
              <el-option style="white-space: unset; max-width: 600px;height: unset;" :key="item.teacherOpenCourseId" :label="item.scheduleSessionTitle" :value="item.teacherOpenCourseScheduleSessionId">
                <div style="font-size: 12px" v-html="item.scheduleSessionTitle"></div>
              </el-option>
            </template>
          </el-select>
          <span slot="footer" class="dialog-footer">
            <el-button @click="importShow = false">取 消</el-button>
            <el-button type="primary" @click="submitImport">确 认</el-button>
          </span>
        </el-dialog>
      </div>
    </div>
</template>
<script>

export default {
  name: 'Timetable',
  props: {
    courseId: { //课程ID
      type: String,
      required:true
    },
    tag:{ //来源
      type: String,
      required:null
    }
  },
  data() {
    return {
      kb_:require("../../../images/course/kb@2x_.png"),
      value1:"",
      tableData:[],

      total: 0,
      limit:8,
      page:1,
      importShow:false,
      teacherOpenCourseScheduleSessionIds:"",
      status:null,
      courseList:[]
    }
  },
  created() {
    this.getInfo();
  },
  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.limit = val;
      this.getInfo();
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.page = val;
      this.getInfo();
    },
    getInfo(){ //获取数据
      let param = {
        limit:this.limit,
        page:this.page,
        teacherOpenCourseScheduleSessionStatus:this.status,
        teacherOpenCourseId:this.courseId
      }
      this.$post("/api/teacherOpenCourseMergeScheduleSession/getPageList.do",param).then((ret) =>{
        if(ret.code == 0){
          this.total = Number(ret.count);
          this.tableData = ret.data;
        }else{
          this.$message({message: ret.msg,type: 'error'});
        }
      });
    },
    ImportInfo(){ //导入课表
      this.teacherOpenCourseScheduleSessionIds = "";
      this.getCourseList();
      this.importShow = true;
    },
    submitImport(){ //提交导出信息
      if(this.$isEmpty(this.teacherOpenCourseScheduleSessionIds)){
        this.$message({message: '请选择课程名称！',type: 'warning'});
        return;
      }
      this.$post("/api/teacherOpenCourseMergeScheduleSession/importScheduleSession.do",{
        teacherOpenCourseScheduleSessionIds:this.teacherOpenCourseScheduleSessionIds,
        teacherOpenCourseId:this.courseId
        }).then((ret)=>{
        if(ret.code == 0){
          this.getInfo();
          this.importShow = false;
          this.$message({message: '提交成功！',type: 'success'});
        }else{
          this.$message({message: ret.msg,type: 'error'});
        }
      });
    },
    addInfo(){ //创建课表
      this.$confirm('是否确定跳转到学校管理员端创建课表?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        window.open(location.origin + '/Login');
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    getCourseList(){
      let param = {
        teacherOpenCourseId:this.courseId,
      }
      this.$get("/api/teacherOpenCourseScheduleSession/getSessionNameList.do",param).then((ret)=>{
        if(ret.code == 0){
          this.courseList = ret.data;
        }
      });
    }
  }
};
</script>
<style  lang="less">
  .course_Timetable{
    padding: 20px;
    border: 1px solid #DEDEDE;
    .content_block{
      background-color: #ffffff;
      .title_img{
        width: 20px;
        height: 20px;
      }
      .class_img{
        float: left;margin-right: 10px;
      }
      .echarts_row{
        padding: 20px;
      }
      .block_time{
        display: initial;
        margin-right: 20px;
      }
      .el-calendar__body{
        th{
          border-top: 1px solid #E5E5E5;
          border-left: 1px solid #E5E5E5;
          background-color: #EFF2F7;
        }
        th:last-child{
          border-right: 1px solid #E5E5E5;
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/Teacher/components/Timetable.vue